import { useFlags } from '@mint-lib/routing-context';

export type OmniConnectorFlags = {
  criteo_integrated: boolean;
  trade_desk_integrated: boolean;
  x_ads_integrated: boolean;
};

export const useOmniConnectorFlags = (): OmniConnectorFlags => {
  const ff = useFlags('@mint/arm', [
    'omniConnectorCriteo',
    'omniConnectorTradeDesk',
    'omniConnectorXads',
  ]);

  return {
    criteo_integrated: ff?.omniConnectorCriteo?.enabled,
    trade_desk_integrated: ff?.omniConnectorTradeDesk?.enabled,
    x_ads_integrated: ff?.omniConnectorXads?.enabled,
  };
};
